<template>
  <v-hover v-slot="{ hover }">
    <v-card
      class="mr-4 d-flex align-center justify-center card-current-thumb"
      height="92px"
      @click="handleEmitSelect"
      :ripple="false"
    >
      <template v-if="thumb && !loadingDelete">
        <div
          :class="`thumb-preview${selected ? '--selected' : ''}`"
          :style="`background: url(${thumb});`"
        ></div>
      </template>
      <template v-else-if="!loadingDelete">
        <v-img
          max-width="50"
          max-height="50"
          src="@/assets/pandaHappy.svg"
        ></v-img>
      </template>

      <div
        class="container__buttons"
        :class="{ 'container__buttons--show': hover }"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              filter
              icon
              class="btn-handle-download"
              @click="handleDownloadThumbnail"
            >
              <v-icon> mdi-download </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('message.pages.video.thumbnails.downloadThumb') }}</span>
        </v-tooltip>
        <template v-if="showCloseBtn">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                filter
                icon
                class="btn-handle-delete ml-1"
                @click="handleDeleteThumbnail"
              >
                <v-icon> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('message.pages.video.thumbnails.deleteThumb') }}</span>
          </v-tooltip>
        </template>
      </div>
      <v-progress-circular
        v-if="loadingDelete"
        :size="22"
        width="3"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  name: 'previewThumbCard',
  props: {
    thumb: {
      type: String,
      required: false,
    },
    showCloseBtn: {
      type: Boolean,
      required: true,
    },
    loadingDelete: {
      type: Boolean,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleDeleteThumbnail() {
      this.$emit('delete')
    },
    handleDownloadThumbnail() {
      this.$emit('download')
    },
    handleEmitSelect(e) {
      if (e.target.tagName === 'I') return
      this.$emit('select')
    },
  },
}
</script>

<style lang="scss">
.container__buttons {
  opacity: 0;
  position: absolute;
  top: 6px;
  right: 6px;
  display: flex;
  transition: opacity 0.3s;
}

.container__buttons--show {
  opacity: 1 !important;
}

.btn-handle-delete,
.btn-handle-download {
  background: #282525;
  height: 24px !important;
  width: 24px !important;
}

.btn-handle-delete span i,
.btn-handle-download span i {
  color: #fff !important;
  height: 17px !important;
  font-size: 17px !important;
  width: 19px !important;
}

.thumb-preview {
  height: 92px;
  width: 150px;
  background-size: cover !important;
  background-position: 50% 50% !important;
  background-repeat: no-repeat !important;
  border-radius: 4px;

  &--selected {
    @extend .thumb-preview;
    border: 2px solid var(--v-brand-base);
  }
}

.card-current-thumb {
  border: 1px solid #d0d1d9;
  border-color: #d0d1d9 !important;
  min-width: 150px !important;
  max-width: 150px !important;
}
</style>
